<template>
  <div class="home">
    <div class="container is-fluid">
      <page-header :entity="$entitiesName.Attachement"
                   :create="openCreateModal">
        <h1 class="title">{{$t('entities.prestationTypes')}}</h1>
      </page-header>
      <datatable ref="prestationtypes"
                 :fetch="$api.fetchTypes"
                 :enableDownload="false"
                 objectName="prestationtypes"
                 identifier="name">
        <div slot="name"
             slot-scope="{ item }"
             :title="$t('common.name')"
             :sortable="true">{{ item.name }}</div>
        <div slot="actions"
             slot-scope="{ item }">
          <router-link :to="'/prestationtype/' + item.id"
                       class="button is-primary">
            <i class="fa fa-search"></i>
          </router-link>
        </div>
      </datatable>
      <modal ref="createPrestationTypesModal"
             @create="createPrestationType"
             :title="$t('prestationTypes.prestationTypeCreation')">
        <div class="columns">
          <div class="column is-half">
            <text-field :label="$t('common.name')"
                        v-model="prototypePrestationType.name"
                        :inline="false"
                        :edit="true"
                        required />
          </div>
        </div>
      </modal>
    </div>
  </div>
</template>
<script>
import axios from 'axios';

export default {
  name: 'prestation-types-list',
  data () {
    return {
      prototypePrestationType: {
        name: '',
      },
      modalIsOpen: false,
    };
  },
  methods: {
    createPrestationType () {
      this.$validator.validateAll().then((result) => {
        if (result) {
          const created = Object.assign({}, this.prototypePrestationType);
          axios
            .post('/prestationtype', created)
            .then((res) => {
              this.closeCreateModal();
              this.$refs.prestationtypes.refresh();
              this.$router.push({
                name: 'PrestationType',
                params: { id: res.data.id },
              });
            });
          this.prototypePrestationType = {
            name: '',
          };
        }
      });
    },
    openCreateModal () {
      this.$refs.createPrestationTypesModal.open();
    },
    closeCreateModal () {
      this.$refs.createPrestationTypesModal.close();
    },
  },
};
</script>

